import React, { useState, useEffect } from 'react';

const InstallPWA = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isIOS, setIsIOS] = useState(false);
    const [isStandalone, setIsStandalone] = useState(false);
    const [showInstructions, setShowInstructions] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const isInStandaloneMode = () => {
            return (window.matchMedia('(display-mode: standalone)').matches) || 
                   (window.navigator.standalone) || 
                   document.referrer.includes('android-app://');
        };

        if (isInStandaloneMode()) {
            setIsStandalone(true);
            return; 
        }

        const userAgent = window.navigator.userAgent.toLowerCase();
        const ios = /iphone|ipad|ipod/.test(userAgent);
        setIsIOS(ios);

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault(); 
            setDeferredPrompt(e);
            setIsVisible(true);
            console.log("PWA Event disparado! Botão deve aparecer."); // Log para debug
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        if (ios) {
            setIsVisible(true);
        }

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    if (isStandalone || !isVisible) return null;

    const handleClick = async () => {
        if (isIOS) {
            setShowInstructions(true);
        } else if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                setDeferredPrompt(null);
                setIsVisible(false);
            }
        }
    };

    return (
        <>
            {/* BOTÃO FLUTUANTE COM Z-INDEX MÁXIMO (z-50 -> z-[9999]) */}
            <button
                onClick={handleClick}
                className="fixed bottom-6 left-1/2 transform -translate-x-1/2 sm:bottom-10 sm:left-auto sm:right-10 sm:transform-none z-[9999] bg-white text-blue-600 px-5 py-3 rounded-full shadow-2xl border border-blue-100 flex items-center gap-3 animate-bounce-slow hover:bg-gray-50 transition-all active:scale-95"
                style={{ 
                    minWidth: '180px', 
                    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
                    border: '2px solid #eff6ff'
                }}
            >
                <div className="bg-blue-100 p-2 rounded-full flex-shrink-0">
                    <i className="fas fa-download text-blue-600 text-sm"></i>
                </div>
                <div className="text-left">
                    <p className="text-[10px] text-gray-500 font-bold uppercase leading-tight">Instalar App</p>
                    <p className="text-sm font-bold text-gray-800 leading-tight">Vintage Praia</p>
                </div>
            </button>

            {/* MODAL DE INSTRUÇÕES (IOS) */}
            {showInstructions && (
                <div className="fixed inset-0 z-[10000] flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fade-in" onClick={() => setShowInstructions(false)}>
                    <div className="bg-white w-full max-w-sm rounded-2xl p-6 relative shadow-2xl mb-4 sm:mb-0" onClick={e => e.stopPropagation()}>
                        <button 
                            onClick={() => setShowInstructions(false)} 
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 bg-gray-100 rounded-full p-1 w-8 h-8 flex items-center justify-center transition-colors"
                        >
                            <i className="fas fa-times"></i>
                        </button>
                        
                        <div className="text-center mb-6">
                            <div className="w-16 h-16 bg-gray-100 rounded-2xl mx-auto mb-4 flex items-center justify-center text-3xl shadow-inner">
                                🍎
                            </div>
                            <h3 className="text-xl font-bold text-gray-800">Instalar no iPhone</h3>
                            <p className="text-sm text-gray-500 mt-2 px-2">Siga estes passos:</p>
                        </div>

                        <div className="space-y-3 text-sm text-gray-700">
                            <div className="flex items-center gap-4 p-3 bg-blue-50 rounded-xl border border-blue-100">
                                <div className="text-xl text-blue-600 w-8 text-center"><i className="fas fa-share-from-square"></i></div>
                                <div>
                                    <p className="font-bold text-blue-900">1. Toque em 'Partilhar'</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-xl border border-gray-100">
                                <div className="text-xl text-gray-700 w-8 text-center"><i className="far fa-square-plus"></i></div>
                                <div>
                                    <p className="font-bold text-gray-900">2. Ecrã Principal</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default InstallPWA;